<mat-toolbar [class]="styleClass ?? ''" class="cfi-menubar">
  @for (item of items; track trackByLabel($index, item); let i = $index) {
    @if (isVisible(item)) {
      <!-- Separator -->
      @if (item.separator) {
        <span class="menubar-separator"></span>
      }

      <!-- Item with submenu -->
      @if (!item.separator && hasSubmenu(item)) {
        <button
          mat-button
          [matMenuTriggerFor]="submenu"
          [disabled]="item.disabled"
          [class]="item.styleClass">
          @if (item.icon) {
            <mat-icon>{{ item.icon }}</mat-icon>
          }
          <span>{{ item.label }}</span>
          <mat-icon class="submenu-indicator">arrow_drop_down</mat-icon>
        </button>

        <!-- Submenu -->
        <mat-menu #submenu="matMenu">
          @for (subItem of item.items || []; track trackByLabel($index, subItem); let j = $index) {
            @if (isVisible(subItem)) {
              <!-- Sub-separator -->
              @if (subItem.separator) {
                <mat-divider></mat-divider>
              }

              <!-- Sub-item with nested submenu -->
              @if (!subItem.separator && hasSubmenu(subItem)) {
                <button
                  mat-menu-item
                  [matMenuTriggerFor]="nestedMenu"
                  [disabled]="subItem.disabled"
                  [class]="subItem.styleClass">
                  @if (subItem.icon) {
                    <mat-icon>{{ subItem.icon }}</mat-icon>
                  }
                  <span>{{ subItem.label }}</span>
                  <mat-icon class="submenu-indicator">arrow_right</mat-icon>
                </button>

                <!-- Nested submenu -->
                <mat-menu #nestedMenu="matMenu">
                  @for (nestedItem of subItem.items || []; track trackByLabel($index, nestedItem)) {
                    @if (isVisible(nestedItem) && !nestedItem.separator) {
                      <button
                        mat-menu-item
                        (click)="onItemClick(nestedItem, $event)"
                        [disabled]="nestedItem.disabled"
                        [class]="nestedItem.styleClass">
                        @if (nestedItem.icon) {
                          <mat-icon>{{ nestedItem.icon }}</mat-icon>
                        }
                        <span>{{ nestedItem.label }}</span>
                      </button>
                    }
                  }
                </mat-menu>
              }

              <!-- Sub-item without submenu -->
              @if (!subItem.separator && !hasSubmenu(subItem)) {
                <button
                  mat-menu-item
                  (click)="onItemClick(subItem, $event)"
                  [disabled]="subItem.disabled"
                  [class]="subItem.styleClass">
                  @if (subItem.icon) {
                    <mat-icon>{{ subItem.icon }}</mat-icon>
                  }
                  <span>{{ subItem.label }}</span>
                </button>
              }
            }
          }
        </mat-menu>
      }

      <!-- Item without submenu -->
      @if (!item.separator && !hasSubmenu(item)) {
        <button
          mat-button
          (click)="onItemClick(item, $event)"
          [disabled]="item.disabled"
          [class]="item.styleClass">
          @if (item.icon) {
            <mat-icon>{{ item.icon }}</mat-icon>
          }
          <span>{{ item.label }}</span>
        </button>
      }
    }
  }
</mat-toolbar>
